const NUMERIC_SEGMENT = /^\d+$/;
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const HEX_SEGMENT = /^[0-9a-f]{16,}$/i;

const isDynamicIdSegment = (segment: string): boolean =>
    NUMERIC_SEGMENT.test(segment) || UUID_SEGMENT.test(segment) || HEX_SEGMENT.test(segment);

export const sanitizePathname = (pathname: string): string => {
    const sanitized = pathname
        .split('/')
        .map((segment: string): string => (isDynamicIdSegment(segment) ? ':id' : segment))
        .join('/');

    return sanitized || '/';
};
